import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class XorSwitch extends PureComponent {
    constructor( props ) {
        super( props );

        this.isControlled = this.props.value !== undefined;
        this.state = {
            value: this.props.value || this.props.defaultValue,
        };
    }
    changeHandler = ( e ) => {
        var value = e.target.value;
        if( !this.isControlled ) {
            this.setState( { value } );
        }
        this.props.onChange( e, value );
    }
    modifyChildren = ( optionProps ) => {
        var children = this.props.children;
        if( children == undefined ) {
            return children;
        }
        var value = this.state.value;
        if( this.isControlled ) {
            value = this.props.value;
        }
        return React.Children.map( this.props.children, ( child ) => {
            return React.cloneElement( child, {
                ...optionProps,
                checked: child.props.value == value,
            } );
        } );
    }
    render() {
        var inlineStyle = { ...this.props.style };

        var optionProps = {
            name: this.props.name,
            onChange: this.changeHandler,
        };
        const children = this.modifyChildren( optionProps );

        return (
            <div className={ `${ this.props.className } ${ style.xorSwitch }` }
            style={ inlineStyle } >
                { children }
            </div>
        );
    }
}
XorSwitch.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    children: PropTypes.oneOfType( [
        PropTypes.array,
        PropTypes.object,
    ] ),
    style: PropTypes.object,
};
XorSwitch.defaultProps = {
    className: '',
    defaultValue: null,
    onChange: () => {},
    onClick: () => {},
};

export default XorSwitch;
